import axios from 'axios'
import { ErrorService, CloudinaryService } from '.'
import { URLS } from '../factories'
import { AffiliateModule, ApplicationModule, AuthModule } from '../store'

function getVehicleById (vehicleId: number, loadVehicleFromQuote: boolean) {
  const tokenString = 'Bearer ' + AuthModule.token!.authenticationToken
  const headersObj = { Authorization: tokenString }

  if (loadVehicleFromQuote) {
    const vehicleApiUrl = AuthModule.isProduction ? URLS.production.vehicleApiUrl : URLS.replica.vehicleApiUrl

    return axios({
      method: 'GET',
      url: vehicleApiUrl + '/v1/vehicle/application',
      headers: headersObj,
      params: { vehicleId: vehicleId, applicationFormVehicleTypeId: 1 }
    })
  } else {
    const vehicleSearchApiUrl = AuthModule.isProduction ? URLS.production.vehicleSearchApiUrl : URLS.replica.vehicleSearchApiUrl

    return axios({
      method: 'GET',
      url: vehicleSearchApiUrl + '/v1/cars',
      headers: headersObj,
      params: { vehicleId: vehicleId }
    })
  }
}

function setFormVehicle (vrm: string, fuelType: string, regYear: string, transmission: string, imageUrl: string) {
  const vehicle = ApplicationModule.vehicle!

  vehicle.vrm = vrm
  vehicle.fuelType = fuelType
  vehicle.registrationYear = regYear
  vehicle.transmission = transmission
  vehicle.imageUrl = imageUrl

  ApplicationModule.updateVehicle(vehicle)
}

export default {
  async loadVehicle () {
    const loadVehicleFromQuote = AffiliateModule.affiliateConfig!.loadVehicleFromQuote === true

    let response = null

    try {
      response = await getVehicleById(Number(ApplicationModule.vehicleID), loadVehicleFromQuote)
    } catch (error: any) {
      ErrorService.submit(error.message, error.stack)
    }

    if (response === null) {
      // TODO: catch server error?
      return
    }

    const responseData = response.data

    let imageUrl = ''

    if (loadVehicleFromQuote) {
      imageUrl = responseData.imageUrl
      setFormVehicle(responseData.vrm, responseData.fuelType, responseData.regYear, responseData.transmission, responseData.imageUrl)
    } else {
      imageUrl = responseData.images ? responseData.images[0] : undefined

      setFormVehicle(responseData.regNumber, responseData.fuel, responseData.year, responseData.trans, imageUrl)
    }

    if (ApplicationModule.vehicle!.imageUrl && ApplicationModule.vehicle!.imageUrl.indexOf('cloudinary') === -1) {
      const cloudinaryVehicleImageUrl = CloudinaryService.getCloudinaryImageUrl(ApplicationModule.vehicle!.imageUrl)
      ApplicationModule.updateCloudinaryVehicleImageUrl(cloudinaryVehicleImageUrl)
    }

    const vehicle = ApplicationModule.vehicle!

    vehicle.make = responseData.make
    vehicle.model = responseData.model
    vehicle.price = responseData.price
    vehicle.mileage = responseData.mileage
    vehicle.colour = responseData.colour
    vehicle.imageUrl = imageUrl
    vehicle.vdpUrl = responseData.vdpUrl
    vehicle.dealerInfoUrl = responseData.dealerInfoUrl

    ApplicationModule.updateVehicle(vehicle)
  }
}
